import { render, staticRenderFns } from "./MatBed.vue?vue&type=template&id=0cc38fa3&"
import script from "./MatBed.vue?vue&type=script&lang=js&"
export * from "./MatBed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports